import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { FieldComponent } from './field.component';

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrls: ['./notes-dialog.component.scss']
})
export class NotesDialogComponent implements OnInit {
  @ViewChild('textField') textField: FieldComponent;

  draftData: string;
  field: string;
  locked: boolean = false;
  previousValue: string;
  value: string;
  versionChanged: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<NotesDialogComponent>) { }

  ngOnInit() {
    this.field = this.data.field;
    this.draftData = this.data.value;
    this.locked = this.data.locked;
    this.previousValue = this.data.previousValue;
    this.versionChanged = this.data.versionChanged;
  }

  onOpen() {
    if (this.versionChanged) {
      this.textField.setPreviousValue(this.previousValue);
    }
    this.textField.focus();
  }

  onValueChange(event) {
    this.value = event.value;
  }

  close() {
    this.dialogRef.close();
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/notes-dialog.component.ts